module.exports = __webpack_public_path__ + "media/images/new_home/like-black-5a0d2ee39759bce44442c0ae2852999d.png";